import { getToken } from '../../Utils/authUtils';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { REPORTS } from '../../constant';

interface Payload {
  _id: string;
  firstName: string;
  reportDiagramHtml: any;
}

export const downloadPDF = createAsyncThunk(
  'Download PDF',
  async (payload: Payload, { rejectWithValue }) => {
    try {
      const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + getToken(),
        },
        body: JSON.stringify({ _id: payload._id, reportDiagramHtml: payload.reportDiagramHtml }),
      };

      const res = await fetch(REPORTS.DOWNLOAD_PDF, requestOptions);

      if (!res.ok) {
        const errorData = await res.json();
        return rejectWithValue(errorData.msg || 'Download PDF Failed.');
      }

      const blob = await res.blob();
      if (blob.type !== 'application/pdf') {
        throw new Error('Invalid PDF file received from server.');
      }

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      const sanitizedFirstName = payload.firstName.replace(/[^a-zA-Z0-9]/g, '');
      link.download = `${sanitizedFirstName}.pdf`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);

      return { msg: 'PDF downloaded successfully.' };
    } catch (error) {
      return rejectWithValue(error.message || 'An error occurred while downloading the PDF.');
    }
  }
);
